import { render, staticRenderFns } from "./myHeader.vue?vue&type=template&id=524a8586&scoped=true"
import script from "./myHeader.vue?vue&type=script&lang=js"
export * from "./myHeader.vue?vue&type=script&lang=js"
import style0 from "./myHeader.vue?vue&type=style&index=0&id=524a8586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a8586",
  null
  
)

export default component.exports